export default class PostPresenter {
  constructor(model, view, appInterface) {
    this.view = view;
    this.appInterface = appInterface;
    this.postId = null;
  }

  async init(postId) {
    this.postId = postId;
    if (this.view.setPostId) {
      this.view.setPostId(postId);
    }
    if (this.view.onBack) {
      this.view.onBack(() => this.appInterface.navigateBack());
    }
  }

  cleanup() {
    if (this.view.cleanup) this.view.cleanup();
  }
}
